import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import Authentication from '../../../../feature-module/authentication';
import {Str,Log,DateTime} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Favorite_Table} from "biz9-favorite";
import {User_Table,User_Logic,User_Title,User_Role,User_Field} from "biz9-user";
import {Message,Type,Url,Title} from "../../../../constant";
import {Image,Toast_Message,App} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Portal_Value_Type,Portal_Field,Portal_Url,Portal_Table,Portal_Remote_Data} from "biz9-portal-app";

/* -- biz9 import end -- */
const Dashboard_Admin_Favorite = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
    const [val_sub_page_title,setValSubPageTitle] = useState(Title.LABEL_CMS_PAGE_TITLE_ADMIN_FAVORITEZ);
    const [favorites,setFavorites] = useState([]);
    const columns = [
    {
    title: "UserName",
       dataIndex: "username",
    render: (text: string, record: any) => (
                       <h2 className="table-avatar d-flex align-items-center">
                          <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user.id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                    <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user.id} className="text-dark">
                    {record.user.username}
                    </Link>
                      </h2>
    ),
       sorter: false
    },
    {
    title: "Title",
       dataIndex: "title",
        render: (text: string, record: any) => (
            <h2 className="table-avatar d-flex align-items-center">
                    <Link to={all_routes.product_app_detail+"?id="+record.parent.id} className="avatar">
                        <ImageWithBasePath src={Image.get_url(record.parent.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                    <Link to={all_routes.product_app_detail+"?id="+record.parent.id} className="text-dark">
                       {record.parent.title}
                        </Link>
                      </h2>
        ),
       sorter: false
    },
    {
    title: "Type",
       dataIndex: "type",
        render: (text: string, record: any) => (
            <>
            {record.parent.type}
            </>
        ),
       sorter: false
    },

    {
    title: "Date & Time",
       dataIndex: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
       sorter: false
    },
    ];
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_data();
    },[]);
    async function get_data() {
        let foreign_user = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.USER,Portal_Field.ID,User_Field.USER_ID,{title:'user'});
        let foreign_parent = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.PRODUCT,Portal_Field.ID,Portal_Field.PARENT_ID,{title:'parent'});
        let option = {foreigns:[foreign_user,foreign_parent]};
        let search = Data_Logic.get_search(Portal_Table.FAVORITE,{});
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setFavorites(data.items);
        Toast_Message.dismiss();
    };
    return (
            <>
          <Toaster />
            <Authentication role={User_Role.SUPER_ADMIN} />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>

            <div className="table-responsive custom-table">
            <Table onUpdate={setFavorites} allow_multiple={false}  table={Portal_Table.FAVORITE} dataSource={favorites} columns={columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
        </>
        );
};
export default Dashboard_Admin_Favorite;
